import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';

export const PoiIntSelectPaymentTypeStripeActions = createActionGroup({
  source: 'POI Int Select Payment Type Component Stripe',
  events: {
    'Stripe Session Created': props<{
      url: string;
    }>(),
    'Create Stripe Checkout Session Error': props<{
      error: HttpErrorResponse;
    }>(),
  },
});
